import { render, staticRenderFns } from "./PesquisaQuantidadeRefeicoes.vue?vue&type=template&id=722244d4&scoped=true"
import script from "./PesquisaQuantidadeRefeicoes.vue?vue&type=script&lang=js"
export * from "./PesquisaQuantidadeRefeicoes.vue?vue&type=script&lang=js"
import style0 from "./PesquisaQuantidadeRefeicoes.vue?vue&type=style&index=0&id=722244d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722244d4",
  null
  
)

export default component.exports